/**
 * 应用根组件
 *
 * 职责：
 *  1. 路由出口
 *  2. 登录失效监听（api 层抛事件 -> 跳登录页）
 *     （轻提示 / 确认框 / 加载遮罩统一由 Element Plus 渲染，见 composables/useToast）
 *  4. Web 端「需要桌面版」引导弹窗（Electron 构建里被条件编译剔除）
 */
<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { onLogout } from '@/api/xajax'
import { useUserStore } from '@/stores/user'
import { useTheme } from '@/composables/useTheme'
import { useUiSize } from '@/composables/useUiSize'
import DesktopRequiredModal from '@/components/WebOnly/DesktopRequiredModal.vue'

const router = useRouter()
const userStore = useUserStore()
const { followSystem } = useTheme()
const { uiSize } = useUiSize()

let offLogout: (() => void) | null = null

onMounted(() => {
  followSystem()
  // 启动即有 token 时拉一次用户信息
  if (userStore.isLogin) userStore.init()

  // 登录失效：清 store + 跳登录页
  offLogout = onLogout(() => {
    userStore.clearLogin()
    const cur = location.hash.replace(/^#/, '') || '/'
    if (!cur.startsWith('/login')) {
      router.replace({ path: '/login', query: { redirect: cur } }).catch(() => {})
    }
  })
})

onUnmounted(() => offLogout?.())
</script>

<template>
  <el-config-provider :size="uiSize">
    <router-view />
    <DesktopRequiredModal />
  </el-config-provider>
</template>
